import Axios from '@/components/api/axios.js'
//监测点api
export default {
	/**
	 * 添加或更新监测点信息
	 */
	saveMonitoringPoint:(pkid,name,memo,deviceNo,unitId,success, failure) => {
		Axios.post('/monitoringPoint/saveMonitoringPoint.do',{
			pkid,
			name,
			memo,
			deviceNo,
			unitId,
		}, success, failure);
	},
	/**
	 * 删除监测点信息
	 */
	deleteMonitoringPoint:(pkid,success, failure) => {
		Axios.post('/monitoringPoint/deleteMonitoringPoint.do', {
			pkid,
		}, success, failure);
	},
	/**
	 * 获取监测点信息列表
	 */
	getMonitoringPointLimit:(pageIndex,pageSize,name,beginTime,endTime,success, failure) => {
		Axios.post('/monitoringPoint/getMonitoringPointLimit.do', {
			pageIndex,
			pageSize,
			name,
			beginTime,
			endTime,
		}, success, failure);
	},
}